<div
    provideParentForm
    class="system-settings-access-config-container"
>
    <ng-content select="system-settings-system-access-config"></ng-content>
    <ng-content select="system-settings-snmp-config"></ng-content>
    <ng-content select="system-settings-client-management-access-config-container"></ng-content>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6 class="full-modal__section-header">
                {{ l10nKeys.legacySslSupportHeader | vtranslate }}
            </h6>
        </div>
    </div>
    <avi-checkbox-container-group [noMarginTop]="true">
        <avi-checkbox
            objectType="{{ objectTypes.PortalConfiguration }}"
            fieldName="legacy_ssl_support"
            name="portal-configuration-legacy-ssl-support"
            [(ngModel)]="portalConfig.legacy_ssl_support"
            id="portal-configuration-legacy-ssl-support"
        >
            {{ l10nKeys.enablePortalLegacySupportLabel | vtranslate }}
        </avi-checkbox>
        <avi-checkbox
            objectType="{{ objectTypes.SystemConfiguration }}"
            fieldName="legacy_ssl_support"
            name="system-configuration-legacy-ssl-support"
            [(ngModel)]="editable.config.legacy_ssl_support"
            id="system-configuration-legacy-ssl-support"
        >
            {{ l10nKeys.enableSystemLegacySupportLabel | vtranslate }}
        </avi-checkbox>
    </avi-checkbox-container-group>
</div>
